/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/keyfigures_medium'
export default icon
